import { compose, withHandlers, withProps } from 'recompose';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { methods as errorMethods } from 'utils/errors';
import { isEmpty } from 'utils/types';

import { selectors as settingsSelectors } from 'state/settings';
import { selectors as authSelectors } from 'state/auth';
import { selectors as errorsSelectors } from 'state/errors';
import { selectors as warningsSelectors } from 'state/warnings';
import {
  actions as orderActions,
  selectors as orderSelectors,
  selectorsByType,
} from 'state/order';

import CardForm from 'components/creditCard/Form/components/CardForm/component';

const enhance = compose(
  withTranslation('CreditCard'),
  connect(
    (state) => {
      const orderType = orderSelectors.getTypeOfOrder(state);

      const quote = selectorsByType.quote[orderType].getQuote(state);

      return {
        billingEmail: settingsSelectors.getFinanceEmail(state),
        country: settingsSelectors.getCountrySettings(state),
        taxNumber: authSelectors.getUserShipperTaxNumber(state),
        fullPrice: Number(quote.gross_full_price),
        errors: errorsSelectors.getErrors(state),
        warnings: warningsSelectors.getWarnings(state),
        hasQuoteError: selectorsByType.quote[orderType].getQuoteError(state),
        isSubmitting: selectorsByType.ui[orderType].getIsSubmitting(state),
        paymentIntentSecret: orderSelectors.getPaymentIntentSecret(state),
      };
    },
    {
      payOrder: orderActions.payOrder,
    }
  ),

  withHandlers({
    handleSubmitPay:
      ({ payOrder }) =>
      ({ paymentIntent }) => {
        payOrder({ paymentIntent });
      },
  }),
  withProps(({ warnings, errors }) => ({
    hasPastError:
      errorMethods.hasPastError(warnings) || errorMethods.hasPastError(errors),
    hasErrors: !isEmpty(errors) || !isEmpty(warnings),
  }))
);

export default enhance(CardForm);
